import { Observable, EMPTY } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ProductService } from '@core';

export function findProductIdFromCategory(categoryId: string, productService: ProductService): Observable<string> {
  return productService.getProductByCategory(categoryId).pipe(
    map((response) => {
      // Get the first product from the items array
      const firstProduct = response.items?.[0];
      return firstProduct?.productId?.toString();
    }),
    // Filter out undefined/null values
    filter((productId) => !!productId),
  );
}
